module.exports = __webpack_public_path__ + "img/distance-green.791902e5.svg";